import { IndoorStandMarkerLabelSection } from 'components/minute/sidebar/MarkerSidebar/IndoorStandMarkerSidebar/IndoorStandMarkerLabelSection';
import { IndoorStandMarkerLogoSection } from 'components/minute/sidebar/MarkerSidebar/IndoorStandMarkerSidebar/IndoorStandMarkerLogoSection';
import { IndoorStandMarkerPinSection } from 'components/minute/sidebar/MarkerSidebar/IndoorStandMarkerSidebar/IndoorStandMarkerPinSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { IIndoorStandWorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIndoorStandWorldMarker;
}

export const IndoorStandMarkerSidebar = (props: Props): JSX.Element => {
    return (
        <S_IndoorStandMarkerSidebar className={props.className}>
            <IndoorStandMarkerLabelSection marker={props.marker} />
            {!props.marker.hasBookingConfiguration && (
                <>
                    <IndoorStandMarkerPinSection marker={props.marker} />
                    <IndoorStandMarkerLogoSection marker={props.marker} />
                </>
            )}
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_IndoorStandMarkerSidebar>
    );
};

const S_IndoorStandMarkerSidebar = styled.div``;
